export default __webpack_public_path__ + "static/media/bring-forward.2e7c1db1.svg";